module.exports = __webpack_public_path__ + "static/media/telegram.ba5dd4df.svg";